function SearchParentsFor(start, cls, top) {
  var result;

  var parent = start.parentNode;
  if (parent && parent.getAttribute) {
    var pcls = parent.getAttribute("class");
    if (pcls) {
      var pclsArray = pcls.split(" ");
      for (var i = 0; i < pclsArray.length; i++) {
        if (pclsArray[i] == cls) {
          result = parent;
          break;
        }
      }
    }

    if (!result && (!top || parent != top)) {
      result = SearchParentsFor(parent, cls, top);
    }
  }

  return result;
}

function ParseQP() {
  var qpd = {};
  var qp = window.location.search.substr(1);
  var pairs = qp.split("&");

  for (var i = 0; i < pairs.length; i++) {
    var tuple = pairs[i].split("=");
    if (tuple && tuple.length == 2) {
      var key = tuple[0];
      var val = tuple[1];
      qpd[key] = decodeURIComponent(val);
    }
  }

  return qpd;
}

function makeDeliveryOptionActive() {
  if ($(window).width() > 768) {
    var tabLinksContainer = $(".tabs.desktop #tab-links")[0];
  } else {
    var tabLinksContainer = $(".tabs.mobile #tab-links")[0];
  }
  var tabAnchorTags = tabLinksContainer.getElementsByTagName("a");
  for (var i = 0; i < tabAnchorTags.length; i++) {
    var anchorTag = tabAnchorTags[i];
    anchorTag.classList.remove("active");

    if (anchorTag.title == "Delivery Options") {
      anchorTag.classList.add("active");
    }
  }

  if ($(window).width() > 768) {
    var tabTextContainer = $(".tabs.desktop")[0];
  } else {
    var tabTextContainer = $(".tabs.mobile")[0];
  }
  var tabTexts = tabTextContainer.getElementsByTagName("section");
  for (var j = 0; j < tabTexts.length; j++) {
    var tabText = tabTexts[j];
    tabText.classList.remove("active");

    if (tabText.dataset.name == "deliveryOptions") {
      tabText.classList.add("active");
    }
  }

  // parent.scrollIntoView( { behavior: "smooth" } )
}

function makeReviewOptionActive() {
  if ($(window).width() > 768) {
    var tabLinksContainer = $(".tabs.desktop #tab-links")[0];
  } else {
    var tabLinksContainer = $(".tabs.mobile #tab-links")[0];
  }
  var tabAnchorTags = tabLinksContainer.getElementsByTagName("a");
  for (var i = 0; i < tabAnchorTags.length; i++) {
    var anchorTag = tabAnchorTags[i];
    anchorTag.classList.remove("active");

    if (anchorTag.title == "Customer reviews") {
      anchorTag.classList.add("active");
    }
  }

  if ($(window).width() > 768) {
    var tabTextContainer = $(".tabs.desktop")[0];
  } else {
    var tabTextContainer = $(".tabs.mobile")[0];
  }
  var tabTexts = tabTextContainer.getElementsByTagName("section");
  for (var j = 0; j < tabTexts.length; j++) {
    var tabText = tabTexts[j];
    tabText.classList.remove("active");

    if (tabText.dataset.name == "reviews") {
      tabText.classList.add("active");
    }
  }

  // parent.scrollIntoView( { behavior: "smooth" } )
}

function ItsInTheFuture(dateStr) {
  var inTheFuture = false;
  var parts = dateStr.split("-");

  if (parts.length == 3) {
    var monthNum = Number(parts[1]) - 1;
    var dt = new Date(parts[2], monthNum, parts[0], 0, 0, 0);

    if (dt.getTime() > new Date().getTime()) {
      inTheFuture = true;
    }
  }

  return inTheFuture;
}

function checkRestockMessage(targetButton) {
  var restockDate;
  var available = false;
  var stock = 0;
  var variantAvailable;
  var productMasterSelect = document.querySelector(".product-details:not(.hidden) select[ name='id' ]");
  if (productMasterSelect && productMasterSelect.selectedIndex >= 0) {
    var option = productMasterSelect.options[productMasterSelect.selectedIndex];
    restockDate = option.getAttribute("data-restock-date");

    if (option.getAttribute("data-variant-available") == "true") {
      available = true;
    }
    var qtyStr = option.getAttribute("data-variant-qty");
    if (qtyStr != undefined) {
      stock = Number(qtyStr);
    }
    variantAvailable = option.getAttribute("data-variant-available");
  }
  var message = document.getElementsByClassName("bridgman-product-in-stock-text");
  var restockContainerall = document.querySelectorAll(".restock-date-target");
  if (message && restockDate && ItsInTheFuture(restockDate)) {
    var messageAll = document.querySelectorAll(".bridgman-product-in-stock-text");
    $.each(messageAll, function (index, message) {
      message.innerHTML = "Available for pre-order";
    });

    $.each(restockContainerall, function (index, restockContainer) {
      var restockMessage = restockContainer.getAttribute("data-restock-msg");

      if (restockContainer.dataset.customRestockMsg && restockContainer.dataset.customRestockMsg != "") {
        restockContainer.textContent = restockContainer.getAttribute("data-custom-restock-msg");
        document.querySelector(".bridgman-product-in-stock-text").innerHTML = "MADE TO ORDER";
      } else {
        restockContainer.textContent = restockMessage + " " + restockDate;
      }
      restockContainer.classList.remove("hidden");
    });
  } else if (message && stock <= 0) {
    var messageAll = document.querySelectorAll(".bridgman-product-in-stock-text");
    $.each(messageAll, function (index, message) {
      message.innerHTML = "Out of stock";
    });

    $(".variant-quantity").removeClass("is-visible");

    $.each(restockContainerall, function (index, restockContainer) {
      restockContainer.classList.add("hidden");

      if (restockContainer.dataset.customRestockMsg && restockContainer.dataset.customRestockMsg != "") {
        restockContainer.textContent = restockContainer.getAttribute("data-custom-restock-msg");
        restockContainer.classList.remove("hidden");
        document.querySelector(".bridgman-product-in-stock-text").innerHTML = "MADE TO ORDER";
      }
    });
  } else {
    var messageAll = document.querySelectorAll(".bridgman-product-in-stock-text");
    $.each(messageAll, function (index, message) {
      message.innerHTML = "In Stock";
    });
    if (stock < 10) {
      $(".variant-quantity").addClass("is-visible");
    } else {
      $(".variant-quantity").removeClass("is-visible");
    }
    $.each(restockContainerall, function (index, restockContainer) {
      restockContainer.classList.add("hidden");
      if (restockContainer.dataset.customRestockMsg && restockContainer.dataset.customRestockMsg != "") {
        restockContainer.textContent = restockContainer.getAttribute("data-custom-restock-msg");
        restockContainer.classList.remove("hidden");
        document.querySelector(".bridgman-product-in-stock-text").innerHTML = "MADE TO ORDER";
      }
    });
  }

  var qtySelector = $("#addToCartForm-product-template .qty-seleter");
  var quoteRequestCta = $("#quoteRequestCta");

  if (targetButton != undefined) {
    var button = targetButton[0];
  } else {
    var button = document.querySelector("#addToCartForm-product-template .submit-btton");
  }

  if (!available) {
    $("#addToCartForm-product-template .submit-btton").find(".primary-text").text($("#addToCartForm-product-template .submit-btton").attr("data-so-label"));
    button.setAttribute("disabled", "disabled");
    if (qtySelector) qtySelector.addClass("disabled");
    //if (quoteRequestCta) quoteRequestCta.addClass("hidden");
  }
  // else if ( stock > 0 )
  else if (stock > 0 && !restockDate) {
    $("#addToCartForm-product-template .submit-btton").find(".primary-text").text($("#addToCartForm-product-template .submit-btton").attr("data-atc-label"));
    button.removeAttribute("disabled", "disabled");
    button.removeAttribute("style", "padding: 10px;");
  } else if (restockDate && ItsInTheFuture(restockDate) && button) {
    $("#addToCartForm-product-template .submit-btton").find(".primary-text").text($(".submit-btton").attr("data-po-label"));
    button.removeAttribute("disabled", "disabled");
    button.removeAttribute("style", "padding: 10px;");
    var children = qtySelector.childNodes;
    for (var i = 0; i < children.length; i++) {
      var child = children[i];
      child.remove();
    }
    var label = qtySelector.getElementsByTagName("label")[0];
    if (label) {
      label.remove();
    }
    var preorderQty = option.getAttribute("data-variant-qty");
    if (preorderQty > 0) {
      if (!document.querySelector(".preorder-message")) {
        var preOrderQtyMessage = document.createElement("p");
        preOrderQtyMessage.classList.add("preorder-message");
        preOrderQtyMessage.innerText = "Preorder quantity: " + preorderQty;
        qtySelector.appendChild(preOrderQtyMessage);
      }
    }
  }
}

function GetCorrectVariant() {
  var selects = document.querySelectorAll(".single-option-selector");
  var options = { option1: "", option2: "", option3: "" };
  var correctOption;

  for (var i = 0; i < selects.length; i++) {
    var select = selects[i];
    options[select.dataset.option] = select.value;
  }

  //update the main select
  var productSelect = document.getElementById("productSelect-product-template");
  for (var i = 0; i < productSelect.options.length; i++) {
    var option = productSelect.options[i];
    option.removeAttribute("selected", "selected");

    if (options.option1 != "" && options.option2 != "" && options.option3 != "") {
      if (option.dataset.option1 == options.option1 && option.dataset.option2 == options.option2 && option.dataset.option3 == options.option3) {
        option.setAttribute("selected", "selected");
        correctOption = option;
        // UpdatePrice( option );
        break;
      }
    } else if (options.option1 != "" && options.option2 != "") {
      if (option.dataset.option1 == options.option1 && option.dataset.option2 == options.option2) {
        option.setAttribute("selected", "selected");
        correctOption = option;
        // UpdatePrice( option );
        break;
      }
    } else if (options.option1 != "") {
      if (option.dataset.option1 == options.option1) {
        option.setAttribute("selected", "selected");
        correctOption = option;
        // UpdatePrice( option );
        break;
      }
    } else {
      //must be a default
      option.setAttribute("selected", "selected");
      correctOption = option;
      // UpdatePrice( option );
      break;
    }
  }

  if (correctOption == undefined) {
    correctOption = document.createElement("option");
    correctOption.disabled = true;
    correctOption.setAttribute("data-price", "");
  }

  return correctOption;
}

function swapVariantImage(correctVariant) {
  const hasImageGallery = !!document.querySelector("#productPhotoGallery");
  if (!hasImageGallery) return;

  const variantImages = document.querySelectorAll("#productPhotoGallery .gallery-item--variant");
  const primarySegment = document.querySelector(".product-photo-gallery-segment--primary");
  let variantImageFound = null;
  variantImages?.forEach((image) => {
    const variantArr = image.dataset.variants.split(",");
    if (variantArr.includes(correctVariant.dataset.variantId)) variantImageFound = image;
  });
  if (variantImageFound !== null) {
    primarySegment?.classList.remove("no-variant");
    variantImages.forEach((image) => {
      if (image.classList.contains("active")) image.classList.remove("active");
      // only the visible variant media belongs in the lightbox group, otherwise
      // every variant image is repeated in it
      image.querySelector(".image-wrapper")?.removeAttribute("data-fancybox");
    });
    variantImageFound.classList.add("active");
    variantImageFound.querySelector(".image-wrapper")?.setAttribute("data-fancybox", "gallery");
    window.scrollTo({ top: 100, behavior: "smooth" });
  }
}

function setupGalleryLoadMore() {
  const loadButton = document.querySelector("#productPhotoGallery .product-photo-gallery__load");
  const secondarySegment = document.querySelector("#productPhotoGallerySecondary");
  if (!loadButton || !secondarySegment) return;

  loadButton.addEventListener("click", function () {
    secondarySegment.classList.add("is-expanded");
    loadButton.setAttribute("aria-expanded", "true");
    const buttonWrapper = loadButton.closest(".product-photo-gallery__more");
    if (buttonWrapper) buttonWrapper.hidden = true;
  });
}

function UpdateOptionalExtras(correctVariant) {
  var optionalExtraSection = document.querySelector(".optionalExtras");
  if (optionalExtraSection) {
    var optionalExtras = optionalExtraSection.querySelectorAll(".optional-single-products");
    for (var i = 0; i < optionalExtras.length; i++) {
      var optionalExtra = optionalExtras[i];
      var input = optionalExtra.querySelector("input");
      var select = optionalExtra.querySelector("select");

      if (select && select.options && select.options.length) {
        for (var j = 0; j < select.options.length; j++) {
          var option = select.options[j];
          if (correctVariant.dataset.allOption == option.dataset.allVal) {
            option.setAttribute("selected", "selected");
            input.value = option.value;
          }
        }
      }
    }
  }
}

window.addEventListener("DOMContentLoaded", function () {
  $(".prod-image").fancybox({
    loop: true,
  });

  setupGalleryLoadMore();

  $(".bridgman-custom-product-option-selector-row .infobtn").on("click", function (e) {
    e.stopPropagation();
    $(".popupinfo").addClass("openpopup");
    $(".overlay").addClass("active");
    $("html").addClass("collectioniconpopup");
  });
  $(".cls_iconpopup").on("click", function () {
    $(".popupinfo").removeClass("openpopup");
    $(".overlay").removeClass("active");
    $("html").removeClass("collectioniconpopup");
  });

  checkRestockMessage();
  var optionSelects = document.querySelectorAll(".single-option-selector");
  if (optionSelects && optionSelects.length) {
    for (var i = 0; i < optionSelects.length; i++) {
      var optionSelect = optionSelects[i];
      optionSelect.addEventListener("change", function (e) {
        var correctVariant = GetCorrectVariant();
        checkRestockMessage();
        swapVariantImage(correctVariant);
        UpdateOptionalExtras(correctVariant);
      });
    }
  }

  $(".product-variants-v2").on("change", function () {
    checkRestockMessage();
  });
});
